module.exports = __webpack_public_path__ + "static/media/bank_icon.bf1de76d.svg";